import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  container: {
    marginRight: 0,
    marginLeft: 0,
    paddingRight: 19,
    paddingLeft: 9,
    paddingTop: 14,
    paddingBottom: 12,
    // borderBottomWidth: 1,
    // borderBottomColor: PALETTE.primaryStrokeLine,
    flexDirection: 'row',
  },
  marketValueContainer: {
    flex: 0.65,
    flexDirection: 'column',
    paddingBottom: 0.5,
  },
  marketValueValue: {
    lineHeight: 28,
  },
  marketValueNoData: {
    color: PALETTE.secondaryText,
  },
  dayChangeContainer: {
    flex: 0.35,
    flexDirection: 'column',
    paddingBottom: 0.5,
    alignItems: 'flex-end',
  },
  dayChangePercentage: {
    lineHeight: 20,
    marginTop: 8,
  },
});
